<template>
  <div class="container">
    <div><mHeaderNav /></div>
    <div>
    <el-row :gutter="20">
      <router-view v-on:footer="footer"/>
    </el-row>
    </div>
   <div v-if="footer_show"><mFooterNav/></div>
  </div>
</template>
<script>
import "@/style/mCommon.scss";
import mHeaderNav from "@/components/m/com/mHeaderNav.vue";
import mFooterNav from "@/components/m/com/mFooterNav.vue";

export default {
  components: {
    mHeaderNav,
    mFooterNav
  },
   data(){

      return {
       footer_show:true,
      }

  },
methods:{
      //是否显示底部
    footer:function (bool) {
          this.footer_show = bool;
      }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/m/com/mLayout.vue